/**
 * Far & Away: Klarna's monthly-payment line (blocks/fa-klarna.liquid). Loads Klarna's web SDK once
 * and, on a Weglot language folder (/de), shows the line in that language where Klarna offers it.
 * Re-rendered buy boxes (colour or set changes) bring fresh placements, which the SDK's own
 * <klarna-placement> element picks up; new ones get their language set here first.
 */
const CLIENT_ID = '0b47b7f6-e0d5-5c1c-9483-9977b3117cef';

/** Languages Klarna offers per country on this account */
const LANGUAGES = { AT: ['de', 'en'], BE: ['en', 'fr', 'nl'], DE: ['de', 'en'], FI: ['en', 'fi', 'sv'], NL: ['en', 'nl'] };

/** @returns {string | null} */
function pageLanguage() {
  try {
    const weglot = /** @type {any} */ (window).Weglot;
    const lang = weglot && typeof weglot.getCurrentLang === 'function' ? weglot.getCurrentLang() : null;
    if (lang) return lang;
  } catch {}
  const match = window.location.pathname.match(/^\/([a-z]{2})(\/|$)/);
  return match ? match[1] : null;
}

/** @param {Element} placement */
function localize(placement) {
  const locale = placement.getAttribute('data-locale') || '';
  const country = locale.split('-')[1];
  const lang = pageLanguage();
  if (country && lang && LANGUAGES[country]?.includes(lang)) {
    const wanted = `${lang}-${country}`;
    if (locale !== wanted) placement.setAttribute('data-locale', wanted);
  }
}

function localizeAll() {
  document.querySelectorAll('klarna-placement[data-fa-klarna]').forEach(localize);
}

if (!window.faKlarnaReady) {
  window.faKlarnaReady = true;
  localizeAll();

  const sdk = document.createElement('script');
  sdk.async = true;
  sdk.src = 'https://js.klarna.com/web-sdk/v1/klarna.js';
  sdk.dataset.clientId = CLIENT_ID;
  sdk.dataset.environment = 'production';
  document.head.append(sdk);

  new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches('klarna-placement[data-fa-klarna]')) localize(node);
        node.querySelectorAll?.('klarna-placement[data-fa-klarna]').forEach(localize);
      }
    }
  }).observe(document.body, { childList: true, subtree: true });

  // Weglot can finish starting after this runs
  setTimeout(localizeAll, 1500);
}
